var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2204_5485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.66666C2.5 4.31304 2.64048 3.9739 2.89052 3.72385C3.14057 3.4738 3.47971 3.33333 3.83333 3.33333H13.1667C13.5203 3.33333 13.8594 3.4738 14.1095 3.72385C14.3595 3.9739 14.5 4.31304 14.5 4.66666V11.3333C14.5 11.6869 14.3595 12.0261 14.1095 12.2761C13.8594 12.5262 13.5203 12.6667 13.1667 12.6667H3.83333C3.47971 12.6667 3.14057 12.5262 2.89052 12.2761C2.64048 12.0261 2.5 11.6869 2.5 11.3333V4.66666Z",
    stroke: "#0071BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.66667L8.5 8.66667L14.5 4.66667",
    stroke: "#0071BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2204_5485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1c0db60b91e110acdb4bc1ee6d41f3b2.svg";
export { ForwardRef as ReactComponent };